import { sortTypeEnum } from '@/constants/global';
// import { whereOperators } from '@/lib/query-parameter/filter';
export default {
    filterOption: {
        // 조회 기간
        // Example) selectedMonth: yyyy-mm
        selectedMonth: '',
        // 한 페이지당 보여질 항목 개수
        pageSize: 15,
        // 현재 페이지
        pageNumber: 0,
        // 검색 필드
        searchWord: {
            // 검색어
            value: '',
            // TODO v.0.7.0에서는 상점명만 검색 가능, 추후 다른 필드로도 검색 가능하도록 업데이트 예정
            // // 검색유형
            // field: '',
            // // 검색조건
            // condition: whereOperators.like,
        },
    },
    sortOption: [
        {
            // 정렬 대상
            field: 'storeName',
            // 정렬 기준
            value: sortTypeEnum.ASC,
        },
    ],
    // 상점정산 리스트
    list: [],
    paginationData: {},
};
